import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "axios";
const getCancellationOptions = (axios) => async (clinicReferenceId, invoiceReferenceId, signal) => {
  const { data } = await axios.options(
    `/api/v1/internal/invoices/clinics/${clinicReferenceId}/invoices/${invoiceReferenceId}/cancel`,
    {
      signal
    }
  );
  return data;
};
const useInvoiceCancellationOptions = (clinicReferenceId, invoiceReferenceId) => {
  const { invoice } = useAxiosProvider();
  if (!invoice) {
    throw new Error("invoice axios instance is not initialized");
  }
  const queryKey = useMemo(
    () => ["invoice-cancellation-options", clinicReferenceId, invoiceReferenceId],
    [clinicReferenceId, invoiceReferenceId]
  );
  const { data, ...queryResult } = useQuery({
    queryKey,
    queryFn: ({ signal }) => getCancellationOptions(invoice)(clinicReferenceId, invoiceReferenceId, signal),
    enabled: Boolean(clinicReferenceId),
    keepPreviousData: true
  });
  return {
    queryKey,
    queryResult,
    data: data ?? []
  };
};
export {
  useInvoiceCancellationOptions
};
